import { useEffect, useState } from "react";
import { CommentaryBar } from "../CommentaryBar";
import { RaceOrder } from "./RaceOrder";
import { SwipeScreen } from "../SwipeScreen";
import { useEventData } from "../DataProvider";
import config from "../../../../../newProject/game.config.json";
import checkeredFlag from "../../../../src/images/flags/checkeredFlag.png";

interface RunningPanelProps {
  showCommentary: boolean;
  showSwipeScreen: boolean;
  showPanel: boolean;
  setCurrentHorse: (horse: string) => void;
  raceStarted?: boolean;
}

export function RunningPanel({
  showCommentary,
  showSwipeScreen,
  showPanel,
  setCurrentHorse,
}: RunningPanelProps) {
  const { eventData } = useEventData();
  const showFlagTime = new Date(eventData.startTime).getTime() + 65000;
  const [showCheckeredFlag, setShowCheckeredFlag] = useState(false);

  // Only set up the checkered flag logic if we're in F1 mode
  useEffect(() => {
    if (config.sportSubType !== "F1") return;
    
    const checkFlagDisplay = () => {
      const currentTime = new Date().getTime();
      setShowCheckeredFlag(currentTime >= showFlagTime);
    };

    // Check immediately and set up interval
    checkFlagDisplay();
    const intervalId = setInterval(checkFlagDisplay, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [showFlagTime]);

  return showPanel ? (
    <div className="absolute inset-0 flex flex-col">
      {config.sportSubType === "F1" && showCheckeredFlag && (
        <img 
          src={checkeredFlag}
          alt="Checkered Flag" 
          className="absolute top-4 left-4 z-10 w-16 h-16"
        />
      )}
      <SwipeScreen show={showSwipeScreen} />
      <div className="flex items-center justify-end flex-1">
        <RaceOrder
          setCurrentHorse={setCurrentHorse}
          className="pointer-events-auto"
        />
      </div>
      <div>
        <CommentaryBar showCommentary={showCommentary} />
      </div>
    </div>
  ) : null;
}